import {
    BILLBOARD_MENU_LOADING,
    BILLBOARD_MENU_SUCCESS,
    BILLBOARD_MENU_ERROR,
    BILLBOARD_MENU_SELECT_PUBLISHED,
    BILLBOARD_MENU_SELECT_RECEIVED,
    BILLBOARD_HOVER_ROW,
    BILLBOARD_DETAIL_SECONDARY_SHOW,
    BILLBOARD_DETAIL_SECONDARY_HIDE,
    BILLBOARD_SHOW_CREATE_SUCCESS,
    BILLBOARD_ADD_FILES_TO_UPLOAD,
    BILLBOARD_RESET_FILES_TO_UPLOAD,
    BILLBOARD_REMOVE_FILE_TO_UPLOAD,
    BILLBOARD_ADD_FILE_TO_REMOVE,
    BILLBOARD_SAVE_CRUD_RECOMPUTE,
    BILLBOARD_SET_PREVIEW,
    BILLBOARD_SET_PREVIEW_PENDING,
    BILLBOARD_RESET_CRUD_FILES,
} from 'constants/ActionTypes';

const initialState = {
    menu: {
        published: {},
        received: {},
        selectedPublished: '',
        selectedReceived: '',
        selectedFavourite: false,
        selectedRecent: false,
        loading: false,
        error: false,
        isReader: true,
    },
    detail: {
        showSecondary: false,
        secondaryType: null,
    },
    crud: {
        files: [],
        filesToRemove: [],
        recompute: true,
        showPreview: false,
        previewPending: false,
    },
    showSuccessDialog: false,
};

export default function reducer(state = initialState, action) {
    let menuState = state.menu;
    let detailState = state.detail;
    let crudState = state.crud;
    switch (action.type) {
        case BILLBOARD_MENU_LOADING:
            return {
                ...state,
                menu: {
                    ...menuState,
                    loading: true,
                },
            };
        case BILLBOARD_MENU_SUCCESS:
            return {
                ...state,
                menu: {
                    ...menuState,
                    loading: false,
                    error: false,
                    published: action.published,
                    received: action.received,
                },
            };
        case BILLBOARD_MENU_ERROR:
            return {
                ...state,
                menu: {
                    ...menuState,
                    loading: false,
                    error: true,
                },
            };
        case BILLBOARD_MENU_SELECT_PUBLISHED:
            return {
                ...state,
                menu: {
                    ...menuState,
                    selectedPublished: action.id,
                    selectedReceived: '',
                    selectedFavourite: false,
                    selectedRecent: false,
                    isReader: false,
                },
                list: { ...initialState.list },
            };
        case BILLBOARD_MENU_SELECT_RECEIVED:
            return {
                ...state,
                menu: {
                    ...menuState,
                    selectedPublished: '',
                    selectedReceived: action.id,
                    selectedFavourite: false,
                    selectedRecent: false,
                    isReader: true,
                },
                list: { ...initialState.list },
            };
        // case BILLBOARD_MENU_SELECT_FAVOURITE:
        //     menuState = menuState
        //         .update('selectedPublished', () => '')
        //         .update('selectedReceived', () => '')
        //         .update('selectedFavourite', () => true)
        //         .update('selectedRecent', () => false)
        //         .update('isReader', () => false);
        //     listState = initialState.list;
        //     return {
        //         ...state,
        //         menu: menuState,
        //         list: listState,
        //     };
        // case BILLBOARD_MENU_SELECT_RECENT:
        //     menuState = menuState
        //         .update('selectedPublished', () => '')
        //         .update('selectedReceived', () => '')
        //         .update('selectedFavourite', () => false)
        //         .update('selectedRecent', () => true)
        //         .update('isReader', () => false);
        //     listState = initialState.list;
        //     return {
        //         ...state,
        //         menu: menuState,
        //         list: listState,
        //     };
        case BILLBOARD_HOVER_ROW:
            return {
                ...state,
                hoverRow: action.payload.enter ? action.payload.rowIndex : -1,
            };
        case BILLBOARD_DETAIL_SECONDARY_SHOW:
            return {
                ...state,
                detail: {
                    ...detailState,
                    showSecondary: true,
                    secondaryType: action.payload.secondaryType,
                },
            };
        case BILLBOARD_DETAIL_SECONDARY_HIDE:
            return {
                ...state,
                detail: {
                    ...detailState,
                    showSecondary: false,
                    secondaryType: null,
                },
            };
        case BILLBOARD_SHOW_CREATE_SUCCESS:
            return {
                ...state,
                showSuccessDialog: action.payload.show,
            };
        case BILLBOARD_ADD_FILES_TO_UPLOAD: {
            const files = action.payload.files;
            let updatedFiles = [...crudState.files];
            if (files.length > 0) {
                for (const file of files) {
                    const filtered = updatedFiles.filter(
                        (f) => f.name === file.name && f.size === file.size,
                    );
                    if (filtered.length === 0) {
                        updatedFiles.push(file);
                    }
                }
            }
            return {
                ...state,
                crud: {
                    ...crudState,
                    files: updatedFiles,
                },
            };
        }
        case BILLBOARD_RESET_FILES_TO_UPLOAD:
            return {
                ...state,
                crud: {
                    ...crudState,
                    files: [],
                },
            };
        case BILLBOARD_REMOVE_FILE_TO_UPLOAD: {
            const updatedFiles = [...crudState.files];
            updatedFiles.splice(action.payload.index, 1);
            return {
                ...state,
                crud: {
                    ...crudState,
                    files: updatedFiles,
                },
            };
        }
        case BILLBOARD_ADD_FILE_TO_REMOVE:
            return {
                ...state,
                crud: {
                    ...crudState,
                    filesToRemove: [...crudState.filesToRemove, action.idFile],
                },
            };
        case BILLBOARD_SAVE_CRUD_RECOMPUTE:
            return {
                ...state,
                crud: {
                    ...crudState,
                    recompute: action.recompute,
                },
            };
        case BILLBOARD_SET_PREVIEW:
            return {
                ...state,
                crud: {
                    ...crudState,
                    showPreview: action.show,
                },
            };
        case BILLBOARD_SET_PREVIEW_PENDING:
            return {
                ...state,
                crud: {
                    ...crudState,
                    previewPending: action.pending,
                },
            };
        case BILLBOARD_RESET_CRUD_FILES:
            return {
                ...state,
                crud: {
                    ...crudState,
                    files: [],
                    filesToRemove: [],
                },
            };
        default:
            return state;
    }
}
